module.exports = __webpack_public_path__ + "img/phonetic-articulation-cards.5d7108e0.png";